export default __webpack_public_path__ + "static/media/p.45b7d076.png";